import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "@/pages/home/components/HeroSection";
import LiveTimeline from "@/pages/home/components/LiveTimeline";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import BrandSection from "@/pages/home/components/BrandSection";
import TestimonialSection from "@/pages/home/components/TestimonialSection";
import FaqPreview from "@/pages/home/components/FaqPreview";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import { SITE_URL } from "@/utils/site";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const target = document.getElementById(hash.replace("#", ""));
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [hash]);

  return (
    <>
      <Seo
        title="瓜料动态 | 今日更新实时吃瓜，跟上最新进展不迷路"
        description="瓜料动态专注娱乐吃瓜资讯，今日更新滚动不停。全网话题、明星动态、影视综艺最新进展集中呈现，实时吃瓜进度一目了然。"
        keywords="瓜料动态,瓜料动态今日更新,瓜料动态实时吃瓜,瓜料动态最新进展"
        path="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "瓜料动态",
            url: SITE_URL,
            inLanguage: "zh-CN",
            potentialAction: {
              "@type": "SearchAction",
              target: `${SITE_URL}/?q={search_term_string}`,
              "query-input": "required name=search_term_string",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "瓜料动态",
            url: SITE_URL,
            description: "娱乐吃瓜资讯整理平台，实时更新今日话题与最新进展。",
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              email: "hello@gualiaodongtai.com",
            },
          },
        ]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <LiveTimeline />
        <CategoryGrid />
        <FeaturedSection />
        <BrandSection />
        <TestimonialSection />
        <FaqPreview />
        <SubscribeSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}